import axios from "../../utils/axios";

export const getVideos = async (tags, search, author, limit, currentPage) => {
    let queryString = "";

    queryString += `&_page=${currentPage}&_limit=${limit}`;

    if (tags?.length > 0) {
        queryString += tags.map((tag) => `&tags_like=${tag}`).join("&");
    }

    if (search !== "") {
        queryString += `&q=${search}`;
    }

    if (author !== "") {
        queryString += `&q=${author}`;
    }

    const response = await axios.get(`/videos/?${queryString}`);
    console.log(response);
    return response;
};
